export default "__VITE_ASSET__3df3d3fd__"